import React, { FC } from 'react';

import {
  Typography,
  IconButton,
  Avatar,
  Box,
  SxProps,
  Theme,
} from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { adminActions, ICalendarEventType } from '@pharmaplan/common';
import { ChipType, SkeletonVariants } from '../../../helpers/Constants';
import strings from '../../../localization';

import CustomChip from '../CustomChip';
import WithSkeleton from '../WithSkeleton';

import styles from './styles';

interface IPharmacistBar {
  name: string;
  title?: string;
  image?: string | null;
  successAction: string;
  type: ICalendarEventType;
  hourlyRate: string | null;
  arrowClick: () => void;
  imageSuccessAction?: string;
  hideHourly?: boolean;
  customStyle?: SxProps<Theme>;
}

const PharmacistBar: FC<IPharmacistBar> = ({
  name,
  image,
  type,
  successAction,
  hourlyRate,
  imageSuccessAction = adminActions.adminPharmacistPictures,
  arrowClick,
  title,
  hideHourly,
  customStyle,
}) => {
  const SkeletonTypography = WithSkeleton({ successAction, variant: 'text' })(
    Typography,
  );
  const SkeletonAvatar = WithSkeleton({
    successAction: imageSuccessAction,
    variant: SkeletonVariants.circular,
    height: 40,
    width: 40,
  })(Avatar);

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: SkeletonVariants.rounded,
  })(Box);

  return (
    <Box
      sx={[styles.container, customStyle] as SxProps}
      onClick={arrowClick}
      component="div"
    >
      {title && (
        <Box sx={styles.titleContainer}>
          <SkeletonTypography sx={styles.title}>{title}</SkeletonTypography>
          <IconButton sx={styles.iconButton}>
            <KeyboardArrowRightIcon sx={styles.rightChevron} />
          </IconButton>
        </Box>
      )}

      <Box sx={styles.contentContainer}>
        {image && <SkeletonAvatar sx={styles.avatar} src={image ?? ''} />}

        <Box sx={styles.footerContainer}>
          <Box sx={styles.nameContainer}>
            <SkeletonTypography sx={styles.name}>{name}</SkeletonTypography>
            <CustomChip type={type} label={strings.booked} />
          </Box>
          {!hideHourly && (
            <SkeletonBox sx={styles.chipContainer}>
              <CustomChip type={ChipType.hourlyRate} label={hourlyRate ?? 0} />
            </SkeletonBox>
          )}
        </Box>
        {!title && (
          <IconButton sx={styles.iconButton}>
            <KeyboardArrowRightIcon sx={styles.rightChevron} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
export default PharmacistBar;
